export default {"src":"/_next/static/media/next-swiper.40557d61.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};